import { Button } from '@krp/ui-kit'

import { QueryState } from '@krp/sale-ui'
import { RmkDialog } from '@krp/sale-ui'
import type { JournalVm } from '../../model/types'

/** «Журнал кассы»: кто и когда садился за кассу и забирал её (право на журнал). */
export function JournalDialog({ journal, onReload, onClose }: { journal: JournalVm; onReload: () => void; onClose: () => void }) {
  return (
    <RmkDialog title="Журнал кассы" size="md" onClose={onClose}>
      <QueryState requestIdHidden query={journal.query} what="Журнал" emptyText="Записей пока нет" onRetry={onReload} />
      {journal.events.length > 0 && (
        <ul className="rmk-journal" aria-label="События кассы">
          {journal.events.map((event, index) => (
            <li key={`${event.at}-${index}`}>
              <b>{event.atText}</b> — {event.title}: {event.actor}
              {event.note !== null && event.note !== '' && <small> ({event.note})</small>}
            </li>
          ))}
        </ul>
      )}
      <div className="aqsi-card__actions">
        <Button variant="ghost" actionId="aqsi.rmk.close-dialog" onClick={onClose}>
          Закрыть
        </Button>
      </div>
    </RmkDialog>
  )
}
